<template>
  <div class="cc-payment-dialog-content input-text-size">
  <v-container>
  <div v-show="isVisibleProp"></div>
    <v-row class="row">
      <v-col cols="4">
        <label class="input-text-size">Taxpayer Information</label>
      </v-col>
      <v-col cols="4">
        <label class="input-text-size">Payment Information</label>
      </v-col>
      <v-col cols="4"></v-col>
      <v-col cols="2">
        <v-text-field
          label="Taxpayer Name"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.paidBy"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          label="Phone Number"
          v-model="editedItem.phoneNo"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          label="Payment Transaction #"
          v-model.number="editedItem.paymentNo"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          label="Merchant Id"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.merchantId"
        ></v-text-field>
      </v-col>
      <v-col cols="4"></v-col>
      <v-col cols="2">
        <v-text-field
          label="Address 1"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.address1"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          label="Email Address"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.emailAddress"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <ClarionDateControl
          :isIsoDate="true"
          label="CC Date"
          v-model="editedItem.paymentDate"
        />
      </v-col>
      <v-col cols="6"></v-col>
      <v-col cols="2">
        <v-text-field
          label="Address 2"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.address2"
        ></v-text-field>
      </v-col>
      <v-col cols="2"></v-col>
      <v-col cols="2">
        <ClarionDateControl
          :isIsoDate="true"
          label="Business Date"
          v-model="editedItem.systemDate"
        />
      </v-col>
      <v-col cols="2">
        <v-select
          label="Payment Type"
          v-model="editedItem.specialPaymentType"
          :items="specialPaymentTypes"
          item-text="description"
          item-value="name"
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-select
          label="Payment Source"
          v-model="editedItem.modeOfPayment"
          :items="modeOfPaymentTypes"
          item-text="description"
          item-value="name"
        ></v-select>
      </v-col>
      <v-col cols="2"></v-col>
      <v-col cols="2">
        <v-text-field
        v-uppercase=globalSettingItem.conEverythingToCaps
          label="City"
          v-model="editedItem.city"
        ></v-text-field>
      </v-col>
      <v-col cols="2"></v-col>
      <v-col cols="2">
        <v-select
          label="Status"
          v-model="editedItem.status"
          :items="statusTypes"
          item-text="description"
          item-value="name"
          @change="onStatusChange"
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-text-field
          label="Transaction ID"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.transactionId"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          label="Total Amount"
          v-model.number="editedItem.amountPaid"
          type="number"
        ></v-text-field>
      </v-col>
      <v-col cols="2"></v-col>
      <v-col cols="2">
        <v-text-field
          label="Zip Code"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.zipCode"
        ></v-text-field>
      </v-col>
      <v-col cols="2"></v-col>
      <v-col cols="2">
        <ClarionDateControl
          :isIsoDate="true"
          label="Paid Date"
          v-model="editedItem.paidClearedDate"
          :isRequired="editedItem.status === 'PAID'"
        />
      </v-col>
    </v-row>
      <!-- <v-col cols="2">
        <v-text-field
          label="Masked Account"
          v-model="editedItem.maskedAccount"
        ></v-text-field>
      </v-col> -->
      <!-- <v-row>
      <v-col cols="2">
        <v-select
          label="Payment Type"
          v-model="editedItem.paymentType"
          :items="paymentTypes"
          item-text="description"
          item-value="name"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2">
        <v-text-field
          label="County"
          v-model="editedItem.county"
        ></v-text-field>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col>
        <TaxDetails
        v-model="editedItem.taxDetails"
          :baseCrudKey="baseCrudKey"
        />
      </v-col>
    </v-row>
  </v-container>
  </div>
</template>

<script>

import {
  mapGetters,
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';
import TaxDetails from './TaxDetails.vue';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  mixins: [GlobalToCaps],
  props: {
    baseCrudKey: {
      type: String,
      default: 'cc-paymentDialog',
    },
  },
  components: {
    TaxDetails,
    ClarionDateControl,
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    ...mapState({
      specialPaymentTypes: (state) => state.enums.TaxCCSpecialPaymentTypeEnum || [],
      statusTypes: (state) => state.enums.TaxCCPaymentStatusEnum || [],
      allModeOfPaymentTypes: (state) => state.enums.TaxCCModeOfPaymentEnum || [],
      nextPaymentNumber: (state) => state.tax.ccPayments.nextPaymentNumber,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    modeOfPaymentTypes() {
      const current = (this.editedItem || {}).modeOfPayment;
      return this.allModeOfPaymentTypes.filter((t) => t.name !== 'IVR' || t.name === current);
    },
    isVisibleProp() {
      const isVisible = this.isVisible(this.baseCrudKey);
      if (isVisible) {
        if (this.isNewItem) {
          this.determinePaymentNo();
        }
      } else {
        this.setPaymentRegPolling(undefined);
      }
      return isVisible;
    },
  },
  watch: {
    'editedItem.paidClearedDate': function paidClearedDateChanged(newVal) {
      if (newVal && this.editedItem.status !== 'PAID') {
        this.editedItem.status = 'PAID';
      }
    },
  },
  methods: {
    ...mapActions('tax/ccPayments', [
      'loadLastPaymentNo',
    ]),
    ...mapMutations('tax/ccPayments', [
      'setPaymentRegPolling',
    ]),
    onStatusChange() {
      if (this.editedItem.status === 'PAID') {
        this.editedItem.paidClearedDate = this.todaysDate;
      } else if (this.editedItem.status === 'OUTSTANDING') {
        this.editedItem.paidClearedDate = null;
        this.editedItem.paymentNo = null;
      }
    },
    getPaymentNo() {
      if (this.isNewItem) {
        this.determineNextPaymentNo();
      }
    },
    determinePaymentNo() {
      if (this.isNewItem) {
        const transPaymentNoPolling = setInterval(
          this.getPaymentNo,
          1200,
        );
        this.setPaymentRegPolling(transPaymentNoPolling);
      }
    },
    determineNextPaymentNo() {
      const loadPaymentNoPromise = this.loadLastPaymentNo();
      loadPaymentNoPromise.then(() => {
        this.editedItem.paymentNo = this.nextPaymentNumber;
      });
    },
  },
};
</script>
